import { mount } from './mount';

mount(document.getElementById('root'));
